// This file is auto-generated by @hey-api/openapi-ts

export type AnswerReq = {
  lang: Language;
  text: string;
};

export enum AutoTextLangLevel {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard'
}

export type AutoTextReq = {
  description?: string | null;
  include_words?: Array<string> | null;
  n_words?: number;
  lang_level?: AutoTextLangLevel;
};

export type AutoTextRes = {
  title: string;
  text: string;
};

export type CategoryRes = {
  category_content: Array<string>;
};

export enum CategoryType {
  PHRASES = 'phrases',
  SIMPLE_TEXTS = 'simple_texts',
  SAYINGS = 'sayings',
  CONVERSATIONS = 'conversations',
  WRITE = 'write'
}

export enum CommunicationBasics {
  GREETINGS = 'greetings',
  QUESTIONS = 'questions',
  EXPRESSIONS = 'expressions'
}

export type ConfigRes = {
  video_channels_def: {
    [key: string]: Array<VideoDef>;
  };
  be_version: string;
  languages: Array<Language>;
  language_codes: {
    [key: string]: string;
  };
  lang_code_to_verbose: {
    [key: string]: string;
  };
};

export type Conversation = {
  scenes: Array<ConversationScene>;
};

export type ConversationScene = {
  title: string;
  description: string;
  img_description?: string;
  type: ConversationType;
  person_a: string;
  person_b: string;
  description_of_person_a: string;
  description_of_person_b: string;
  conversation: Array<ConversationStep>;
  voice_type?: LangVoiceType;
};

export type ConversationStep = {
  content: string;
  person: string;
  task: string;
};

export enum ConversationType {
  INIT_STEP = 'init_step',
  TEXT_ONLY = 'text_only',
  AUDIO_ONLY = 'audio_only',
  CHAT = 'chat',
  CHAT_AUDIO = 'chat_audio',
  EMAIL = 'email'
}

export type EmailReq = {
  app_name: string;
  tier: string;
  env?: string | null;
  to?: Array<string> | null;
  subject: string;
  message: {
    [key: string]: unknown;
  };
};

export enum EntertainmentAndLeisure {
  ENTERTAINMENT = 'entertainment',
  LEISURE = 'leisure'
}

export type FeedArticle = {
  id: string;
  short_id: string;
  title: string;
  link: string;
  published_at: string;
  source_url: string;
  source: string;
  image_url?: string | null;
  created_summary?: string | null;
  created_content?: string | null;
  parsed_url: string;
};

export type FeedHeadline = {
  id: string;
  short_id: string;
  title: string;
  link: string;
  published_at: string;
  source_url: string;
  source: string;
  image_url?: string | null;
};

export enum FeelingsAndEmotions {
  POSITIVE_EMOTIONS = 'positive_emotions',
  NEGATIVE_EMOTIONS = 'negative_emotions',
  NEUTRAL_OR_MIXED_FEELINGS = 'neutral_or_mixed_feelings'
}

export enum FoodAndDining {
  FOOD = 'food',
  DRINKS = 'drinks',
  DINING = 'dining'
}

export enum GoogleRssTopic {
  WORLD = 'world',
  BUSINESS = 'business',
  TECHNOLOGY = 'technology',
  ENTERTAINMENT = 'entertainment',
  SCIENCE = 'science',
  SPORTS = 'sports',
  HEALTH = 'health',
  NATION = 'nation'
}

export type HTTPValidationError = {
  detail?: Array<ValidationError>;
};

export enum HealthAndWellBeing {
  HEALTH = 'health',
  WELL_BEING = 'well_being'
}

export type KlexikonArticle = {
  title: string;
  title_de: string;
  teaser: string;
  paragraphs: Array<KlexikonParagraph>;
  image_url: string;
};

export type KlexikonParagraph = {
  title?: string | null;
  content: string;
  image_urls?: Array<string>;
};

export type KlexikonTeaserRes = {
  title: string;
  title_de: string;
  teaser: string;
  image_url: string;
};

export enum LangVoiceType {
  MALE = 'male',
  FEMALE = 'female'
}

export enum Language {
  DE = 'de',
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  IT = 'it',
  PT = 'pt',
  RU = 'ru',
  PL = 'pl'
}

export type LoadCountsRes = {
  feeds: {
    [key: string]: number;
  };
  videos: {
    [key: string]: number;
  };
  klexikon: number;
};

export enum MainCategories {
  COMMUNICATION_BASICS = 'communication_basics',
  FEELINGS_AND_EMOTIONS = 'feelings_and_emotions',
  TRAVEL_AND_DIRECTIONS = 'travel_and_directions',
  NUMBERS_AND_QUANTITY = 'numbers_and_quantity',
  TIME_AND_DATES = 'time_and_dates',
  ENTERTAINMENT_AND_LEISURE = 'entertainment_and_leisure',
  HEALTH_AND_WELL_BEING = 'health_and_well_being',
  SOCIAL_CONTEXTS = 'social_contexts',
  FOOD_AND_DINING = 'food_and_dining'
}

export type MessageCheckForType = {
  content: string;
  type: OpenAiRoleType;
  value?: string | number | null;
  label: string;
};

export enum NubmersAndQuantity {
  NUMBERS = 'numbers',
  QUANTITY = 'quantity'
}

export type OpenAiChatMessage = {
  role: OpenAiRoleType;
  content: string;
  check_for?: MessageCheckForType | null;
  on_success_sys_msg?: string | null;
};

export enum OpenAiRoleType {
  SYSTEM = 'system',
  USER = 'user',
  ASSISTANT = 'assistant'
}

export enum SocialContexts {
  SOCIAL = 'social',
  CULTURAL = 'cultural',
  RELIGIOUS = 'religious',
  POLITICAL = 'political'
}

export enum TimeAndDates {
  TIME = 'time',
  DATES = 'dates'
}

export enum TravelAndDirections {
  DIRECTIONS = 'directions',
  LOCATIONS = 'locations',
  TRANSPORTATION = 'transportation',
  ACCOMODATION = 'accomodation'
}

export type ValidationError = {
  loc: Array<string | number>;
  msg: string;
  type: string;
};

export type Video = {
  view_count: number;
  like_count: number;
  id: string;
  title: string;
  description: string;
  published_at: string;
  channel_id: string;
  channel_title: string;
  thumbnail_url: string;
  transcript: Array<{
    [key: string]: unknown;
  }>;
};

export type VideoDef = {
  title: string;
  channel_id: string;
};

export type WordsReq = {
  words: Array<string>;
};

export type WriteCorrectionReq = {
  task: string;
  subject: string;
  content: string;
  needs_to_contain: Array<string>;
};

export type WriteCorrectionRes = {
  overall_analysis: string;
  needs_to_contain_analysis: string;
  spelling_errors: string;
  grammar_errors: string;
  rate: number;
};

export type WriteEmailTask = {
  title: string;
  description: string;
  needs_to_contain: Array<string>;
  to: string;
  min_words: number;
};

export type GetTranslationV1WordInfoTranslationGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetTranslationV1WordInfoTranslationGetResponse = unknown;

export type GetTranslationV1WordInfoTranslationGetError = HTTPValidationError;

export type GetTranslationSentenceV1WordInfoTranslationSentenceGetData = {
  query: {
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetTranslationSentenceV1WordInfoTranslationSentenceGetResponse = unknown;

export type GetTranslationSentenceV1WordInfoTranslationSentenceGetError = HTTPValidationError;

export type GetImageV1WordInfoImageGetData = {
  query: {
    example: string;
    q: string;
  };
};

export type GetImageV1WordInfoImageGetResponse = unknown;

export type GetImageV1WordInfoImageGetError = HTTPValidationError;

export type GetExampleV1WordInfoExampleGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    q: string;
  };
};

export type GetExampleV1WordInfoExampleGetResponse = unknown;

export type GetExampleV1WordInfoExampleGetError = HTTPValidationError;

export type GetExamplesV1WordInfoExamplesGetData = {
  query: {
    context_sentence?: string | null;
    count?: number;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetExamplesV1WordInfoExamplesGetResponse = unknown;

export type GetExamplesV1WordInfoExamplesGetError = HTTPValidationError;

export type GetEmotionalExamplesV1WordInfoEmotionalExamplesGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetEmotionalExamplesV1WordInfoEmotionalExamplesGetResponse = unknown;

export type GetEmotionalExamplesV1WordInfoEmotionalExamplesGetError = HTTPValidationError;

export type GetImagesUnsplashV1WordInfoImagesGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetImagesUnsplashV1WordInfoImagesGetResponse = unknown;

export type GetImagesUnsplashV1WordInfoImagesGetError = HTTPValidationError;

export type GetSynonymsV1WordInfoSynonymsGetData = {
  query: {
    foreign: Language;
    q: string;
  };
};

export type GetSynonymsV1WordInfoSynonymsGetResponse = unknown;

export type GetSynonymsV1WordInfoSynonymsGetError = HTTPValidationError;

export type GetAntonymsV1WordInfoAntonymsGetData = {
  query: {
    foreign: Language;
    q: string;
  };
};

export type GetAntonymsV1WordInfoAntonymsGetResponse = unknown;

export type GetAntonymsV1WordInfoAntonymsGetError = HTTPValidationError;

export type GetMainTranslationsV1WordInfoMainTranslationsGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q?: string | null;
    q_en?: string | null;
    translate_type: string;
    word_type?: string | null;
  };
};

export type GetMainTranslationsV1WordInfoMainTranslationsGetResponse = unknown;

export type GetMainTranslationsV1WordInfoMainTranslationsGetError = HTTPValidationError;

export type GetExtensionsV1WordInfoExtensionsGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
    q_en: string;
    word_type?: string | null;
  };
};

export type GetExtensionsV1WordInfoExtensionsGetResponse = unknown;

export type GetExtensionsV1WordInfoExtensionsGetError = HTTPValidationError;

export type GetMappingsV1WordInfoMappingsGetData = {
  query: {
    foreign_text: string;
    native: Language;
  };
};

export type GetMappingsV1WordInfoMappingsGetResponse = unknown;

export type GetMappingsV1WordInfoMappingsGetError = HTTPValidationError;

export type GetDefinitionV1WordInfoDefinitionGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetDefinitionV1WordInfoDefinitionGetResponse = unknown;

export type GetDefinitionV1WordInfoDefinitionGetError = HTTPValidationError;

export type GetArticleV1WordInfoArticleGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetArticleV1WordInfoArticleGetResponse = unknown;

export type GetArticleV1WordInfoArticleGetError = HTTPValidationError;

export type GetConjugationsV1WordInfoConjugationsGetData = {
  query: {
    context_sentence?: string | null;
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetConjugationsV1WordInfoConjugationsGetResponse = unknown;

export type GetConjugationsV1WordInfoConjugationsGetError = HTTPValidationError;

export type GetGrammerV1WordInfoGrammerGetData = {
  query: {
    foreign: Language;
    native: Language;
    q: string;
  };
};

export type GetGrammerV1WordInfoGrammerGetResponse = unknown;

export type GetGrammerV1WordInfoGrammerGetError = HTTPValidationError;

export type GetImageSentenceV1WordInfoImageSentenceGetData = {
  query: {
    foreign: Language;
    q: string;
  };
};

export type GetImageSentenceV1WordInfoImageSentenceGetResponse = unknown;

export type GetImageSentenceV1WordInfoImageSentenceGetError = HTTPValidationError;

export type GetMostCommonWordsV1WordInfoMostCommonWordsGetData = {
  body?: Array<string>;
  query: {
    foreign: Language;
    n?: number;
    q: string;
  };
};

export type GetMostCommonWordsV1WordInfoMostCommonWordsGetResponse = unknown;

export type GetMostCommonWordsV1WordInfoMostCommonWordsGetError = HTTPValidationError;

export type GetExampleSentenceV1WordInfoExampleSentencePostData = {
  body: WordsReq;
  query: {
    foreign: Language;
  };
};

export type GetExampleSentenceV1WordInfoExampleSentencePostResponse = unknown;

export type GetExampleSentenceV1WordInfoExampleSentencePostError = HTTPValidationError;

export type ReturnAudioFileV1FileAudioLangExtQgetData = {
  path: {
    ext: string;
    lang: Language;
    q: string;
  };
  query: {
    voice: LangVoiceType;
  };
};

export type ReturnAudioFileV1FileAudioLangExtQgetResponse = unknown;

export type ReturnAudioFileV1FileAudioLangExtQgetError = HTTPValidationError;

export type ReturnImageFileV1FileImageNameGetData = {
  path: {
    name: string;
  };
  query?: {
    dir?: string;
  };
};

export type ReturnImageFileV1FileImageNameGetResponse = unknown;

export type ReturnImageFileV1FileImageNameGetError = HTTPValidationError;

export type SplitChineseSentenceV1SentencesSplitChineseSentenceStentenceGetData = {
  path: {
    stentence: string;
  };
};

export type SplitChineseSentenceV1SentencesSplitChineseSentenceStentenceGetResponse = unknown;

export type SplitChineseSentenceV1SentencesSplitChineseSentenceStentenceGetError =
  HTTPValidationError;

export type GetConfigV1ConfigGetResponse = ConfigRes;

export type GetConfigV1ConfigGetError = unknown;

export type GetLoadCountsV1ConfigLoadCountsGetData = {
  query: {
    lang: Language;
  };
};

export type GetLoadCountsV1ConfigLoadCountsGetResponse = LoadCountsRes;

export type GetLoadCountsV1ConfigLoadCountsGetError = HTTPValidationError;

export type GetHeadlineByIdxV1FeedsGetData = {
  query: {
    feed_idx: number;
    foreign: Language;
    topic: GoogleRssTopic;
  };
};

export type GetHeadlineByIdxV1FeedsGetResponse = FeedHeadline;

export type GetHeadlineByIdxV1FeedsGetError = HTTPValidationError;

export type GetHeadlineByIdV1FeedsIdGetData = {
  path: {
    id: string;
  };
  query: {
    foreign: Language;
    topic: GoogleRssTopic;
  };
};

export type GetHeadlineByIdV1FeedsIdGetResponse = FeedHeadline;

export type GetHeadlineByIdV1FeedsIdGetError = HTTPValidationError;

export type GetArticleV1FeedsSummaryTopicIdGetData = {
  path: {
    id: string;
    topic: GoogleRssTopic;
  };
  query: {
    foreign: Language;
  };
};

export type GetArticleV1FeedsSummaryTopicIdGetResponse = FeedArticle;

export type GetArticleV1FeedsSummaryTopicIdGetError = HTTPValidationError;

export type GetVideoByIdxV1VideosChannelChannelIdGetData = {
  path: {
    channel_id: string;
  };
  query: {
    lang: Language;
    video_idx: number;
  };
};

export type GetVideoByIdxV1VideosChannelChannelIdGetResponse = Video;

export type GetVideoByIdxV1VideosChannelChannelIdGetError = HTTPValidationError;

export type GetVideoByIdV1VideosIdGetData = {
  path: {
    id: string;
  };
};

export type GetVideoByIdV1VideosIdGetResponse = Video;

export type GetVideoByIdV1VideosIdGetError = HTTPValidationError;

export type GetTeasersV1KlexikonTeasersGetData = {
  query: {
    lang: Language;
    n?: number;
  };
};

export type GetTeasersV1KlexikonTeasersGetResponse = Array<KlexikonTeaserRes>;

export type GetTeasersV1KlexikonTeasersGetError = HTTPValidationError;

export type GetArticleV1KlexikonArticlesTitleGetData = {
  path: {
    title: string;
  };
  query: {
    lang: Language;
  };
};

export type GetArticleV1KlexikonArticlesTitleGetResponse = KlexikonArticle;

export type GetArticleV1KlexikonArticlesTitleGetError = HTTPValidationError;

export type GetBookContentV1BooksContentBookUrlGetData = {
  path: {
    book_url: string;
  };
};

export type GetBookContentV1BooksContentBookUrlGetResponse = unknown;

export type GetBookContentV1BooksContentBookUrlGetError = HTTPValidationError;

export type AnswerToTextV1ChatAnswerToTextPostData = {
  body: AnswerReq;
  query?: {
    chat_id?: string | null;
  };
};

export type AnswerToTextV1ChatAnswerToTextPostResponse = unknown;

export type AnswerToTextV1ChatAnswerToTextPostError = HTTPValidationError;

export type AddChatMessageV1ChatAddChatMessagePostData = {
  body: Array<OpenAiChatMessage>;
  query: {
    chat_id?: string | null;
    lang: Language;
  };
};

export type AddChatMessageV1ChatAddChatMessagePostResponse = unknown;

export type AddChatMessageV1ChatAddChatMessagePostError = HTTPValidationError;

export type AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostData = {
  body: AnswerReq;
  path: {
    category:
      | CommunicationBasics
      | FeelingsAndEmotions
      | TravelAndDirections
      | NubmersAndQuantity
      | TimeAndDates
      | EntertainmentAndLeisure
      | HealthAndWellBeing
      | SocialContexts
      | FoodAndDining;
    main_category: MainCategories;
  };
  query: {
    chat_id?: string | null;
    step_idx: number;
    user_step_idx: number;
  };
};

export type AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostResponse =
  unknown;

export type AnswerToConversationV1ChatAnswerToConversationMainCategoryCategoryPostError =
  HTTPValidationError;

export type GetConversationsV1CategoryConversationsMainCategoryCategoryGetData = {
  path: {
    category:
      | CommunicationBasics
      | FeelingsAndEmotions
      | TravelAndDirections
      | NubmersAndQuantity
      | TimeAndDates
      | EntertainmentAndLeisure
      | HealthAndWellBeing
      | SocialContexts
      | FoodAndDining;
    main_category: MainCategories;
  };
  query: {
    lang: Language;
  };
};

export type GetConversationsV1CategoryConversationsMainCategoryCategoryGetResponse = Conversation;

export type GetConversationsV1CategoryConversationsMainCategoryCategoryGetError =
  HTTPValidationError;

export type GetWriteTaskV1CategoryWriteMainCategoryCategoryGetData = {
  path: {
    category:
      | CommunicationBasics
      | FeelingsAndEmotions
      | TravelAndDirections
      | NubmersAndQuantity
      | TimeAndDates
      | EntertainmentAndLeisure
      | HealthAndWellBeing
      | SocialContexts
      | FoodAndDining;
    main_category: MainCategories;
  };
  query: {
    lang: Language;
  };
};

export type GetWriteTaskV1CategoryWriteMainCategoryCategoryGetResponse = WriteEmailTask;

export type GetWriteTaskV1CategoryWriteMainCategoryCategoryGetError = HTTPValidationError;

export type GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetData = {
  path: {
    category:
      | CommunicationBasics
      | FeelingsAndEmotions
      | TravelAndDirections
      | NubmersAndQuantity
      | TimeAndDates
      | EntertainmentAndLeisure
      | HealthAndWellBeing
      | SocialContexts
      | FoodAndDining;
    category_type: CategoryType;
    main_category: MainCategories;
  };
  query: {
    lang: Language;
  };
};

export type GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetResponse = CategoryRes;

export type GetCategoryV1CategoryCategoryTypeMainCategoryCategoryGetError = HTTPValidationError;

export type SendEmailV1EmailSendPostData = {
  body: EmailReq;
};

export type SendEmailV1EmailSendPostResponse = unknown;

export type SendEmailV1EmailSendPostError = HTTPValidationError;

export type GetAutoTextV1AutoTextPostData = {
  body: AutoTextReq;
  query: {
    lang: Language;
  };
};

export type GetAutoTextV1AutoTextPostResponse = AutoTextRes;

export type GetAutoTextV1AutoTextPostError = HTTPValidationError;

export type GetTextCorrectionV1WriteCorrectPostData = {
  body: WriteCorrectionReq;
  query: {
    lang: Language;
  };
};

export type GetTextCorrectionV1WriteCorrectPostResponse = WriteCorrectionRes;

export type GetTextCorrectionV1WriteCorrectPostError = HTTPValidationError;
